import type { TypedSupabaseClient } from '../client';
import type { Json } from '../../../supabase-client/src/database.types';
import type { IUserPreferencesRepository } from '../../../interfaces/src';

export class SupabaseUserPreferencesRepository implements IUserPreferencesRepository {
  constructor(private supabase: TypedSupabaseClient) {}

  async get(key: string): Promise<unknown | null> {
    const { data: { user } } = await this.supabase.auth.getUser();
    if (!user) return null;

    const { data, error } = await this.supabase
      .from('user_preferences')
      .select('preference_value')
      .eq('user_id', user.id)
      .eq('preference_key', key)
      .maybeSingle();

    if (error) throw error;
    if (!data) return null;
    return (data as Record<string, unknown>)['preference_value'];
  }

  async set(key: string, value: unknown): Promise<void> {
    const { data: { user } } = await this.supabase.auth.getUser();
    if (!user) throw new Error('Not authenticated');

    const { error } = await this.supabase
      .from('user_preferences')
      .upsert({
        user_id: user.id,
        preference_key: key,
        preference_value: value as Json,
        updated_at: new Date().toISOString(),
      }, { onConflict: 'user_id,preference_key' });

    if (error) throw error;
  }
}
